import { IconProps } from "../../../lib/types";

const Age: React.FC<IconProps> = ({className}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.392"
    height="36.617"
    viewBox="0 0 24.392 36.617"
    className={className}
  >
    <path
      d="M8.573 19.906a3.955 3.955 0 10-6.359 0A3.331 3.331 0 000 23.044v4.719a2.386 2.386 0 001.8 2.309v4.162a2.385 2.385 0 002.382 2.382h2.427a2.385 2.385 0 002.382-2.382v-4.161a2.386 2.386 0 001.8-2.309v-4.72a3.331 3.331 0 00-2.218-3.138zm-3.18-4.866a2.517 2.517 0 11-2.517 2.517 2.517 2.517 0 012.517-2.513zm3.955 12.719a.944.944 0 01-.944.944H7.55v5.528a.944.944 0 01-.944.944H4.18a.944.944 0 01-.944-.944v-5.525h-.854a.944.944 0 01-.944-.944v-4.718a1.888 1.888 0 011.888-1.888h.421a3.95 3.95 0 003.293 0h.421a1.888 1.888 0 011.888 1.888zM24.32 18.118l-2.121-8.731a2.561 2.561 0 00-.893-1.413 2.522 2.522 0 00-.242-.17 4.677 4.677 0 10-6.951 0 2.519 2.519 0 00-.242.17 2.561 2.561 0 00-.893 1.413l-2.12 8.731a2.551 2.551 0 002.482 3.142h.688v3.14a2.82 2.82 0 002.817 2.817h1.488A2.82 2.82 0 0021.15 24.4v-3.141h.688a2.551 2.551 0 002.482-3.141zM17.586 1.7a2.976 2.976 0 11-2.973 2.977A2.976 2.976 0 0117.586 1.7zm4.252 17.858h-2.389V24.4a1.116 1.116 0 01-1.116 1.116h-1.488a1.116 1.116 0 01-1.116-1.116v-4.841h-2.392a.851.851 0 01-.829-1.039l2.126-8.74a.85.85 0 01.829-.662h.656a4.678 4.678 0 002.939 0h.656a.85.85 0 01.829.662l2.126 8.74a.851.851 0 01-.828 1.039z"
    ></path>
  </svg>
    );
}
 
export default Age;